import React from 'react';
import { FileText, Clock, MapPin, Shield, Star } from 'lucide-react';
export function Hero() {
  return <section className="bg-charcoal overflow-hidden pt-10 pb-12 md:pt-16 md:pb-16" data-id="element-216">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="flex flex-col items-center text-center" data-id="element-218">
          {/* Pill badge */}
          <div className="inline-block mb-6" data-id="element-219">
            <span className="inline-block bg-gold/10 text-gold-light border border-gold/30 rounded-full px-5 py-2 text-sm font-semibold tracking-wide" data-id="element-220">
              El estrés de no dormir, solucionado de una vez
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.05] tracking-tight mb-6 max-w-4xl" data-id="element-221">
            El descanso de tu hijo.
            <br data-id="element-222" />
            <span className="text-gold" data-id="element-223">Resuelto hoy.</span>
          </h1>

          {/* Short subhead */}
          <p className="text-lg md:text-xl text-[#8a9ab0] max-w-2xl mx-auto mb-8 leading-relaxed font-medium" data-id="element-224">
            Protocolos + rutinas + herramientas visuales.
            <br data-id="element-225" />
            Todo listo. Sin buscar nada.
          </p>

          {/* Social proof */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 mb-10" data-id="element-226">
            <div className="flex text-gold" data-id="element-227">
              {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-228" />)}
            </div>
            <p className="text-base md:text-lg text-gray-200 italic" data-id="element-229">
              "Ahora se duerme solo. Sin hacer drama."
            </p>
          </div>

          {/* Image */}
          <div className="relative w-full max-w-3xl mx-auto mb-10" data-id="element-230">
            <div className="absolute inset-0 bg-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-231"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pUUVmZyKAsEqr42SgBJrUm/MockUp.png" alt="MegaPack Descanso Profundo Listo - Zentral Pro" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" loading="eager" fetchPriority="high" decoding="async" data-id="element-232" />
          </div>

          {/* CTA Button — gold gradient with dark text */}
          <div className="w-full sm:w-auto mb-10" data-id="element-233">
            <a href="#precios" className="block w-full sm:w-auto text-center bg-gradient-to-br from-gold via-gold-light to-gold hover:brightness-110 text-[#1a1000] font-bold py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all text-base md:text-lg" data-id="element-234">
              → Quiero mi MegaPack ahora
            </a>
          </div>

          {/* Trust Indicators — 2x2 grid */}
          <div className="grid grid-cols-2 gap-x-10 gap-y-4 text-sm md:text-base text-[#8a9ab0] mb-10 max-w-md mx-auto" data-id="element-235">
            <div className="flex items-center gap-2 justify-start" data-id="element-236">
              <Clock className="w-5 h-5 text-gold shrink-0" data-id="element-237" />
              <span data-id="element-238">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-2 justify-start" data-id="element-239">
              <FileText className="w-5 h-5 text-gold shrink-0" data-id="element-240" />
              <span data-id="element-241">100% PDF</span>
            </div>
            <div className="flex items-center gap-2 justify-start" data-id="element-242">
              <Shield className="w-5 h-5 text-gold shrink-0" data-id="element-243" />
              <span data-id="element-244">7 días de garantía</span>
            </div>
            <div className="flex items-center gap-2 justify-start" data-id="element-245">
              <MapPin className="w-5 h-5 text-gold shrink-0" data-id="element-246" />
              <span data-id="element-247">Adaptado a Argentina</span>
            </div>
          </div>

          {/* Final tagline */}
          <div className="w-full max-w-2xl mx-auto pt-8 border-t border-white/10" data-id="element-248">
            <p className="text-sm md:text-base text-[#6a7a8a]" data-id="element-249">
              Todos los problemas de sueño. Sin improvisar. Sin perder más
              noches.
            </p>
          </div>
        </div>
      </div>
    </section>;
}